<template>
	<v-list
		v-if="notes.length > 0"
		max-width="600"
		max-height="400"
		class="overflow-y-auto"
		v-bind="$attrs"
	>
		<v-list-item
			v-for="noteDay in constructTimeline()"
			:key="noteDay[0].date"
			lines="two"
			class="px-3"
		>
			<span
				class="d-flex justify-center date-span"
			>
				<v-chip>{{ noteDay[0].date }}</v-chip>
			</span>
			<v-card
				v-for="note in noteDay"
				:key="note.id"
				class="mt-3"
				:style="
					`background-color: rgba(${
						note.createdBy === $gettext('System') ? '1, 1, 1, 0.05' : '226, 242, 220, 0.5'
					})`
				"
			>
				<v-card-text>
					<v-list-item-title
						style="color: black"
						class="d-flex align-center"
					>
						{{ note.createdBy }} - {{ note.time }}
						<v-spacer />
						<anonymize-note-button
							v-if="anonymized"
							v-can="'user.anonymize'"
							:note-id="note.id"
							:model-name="modelName"
						/>
					</v-list-item-title>
					<v-divider class="my-1" />
					<div
						v-for="noteLine in note.note.split('\n')"
						:key="noteLine"
						style="color: black"
					>
						<translate>{{ noteLine }}</translate><br>
					</div>
				</v-card-text>
			</v-card>
		</v-list-item>
	</v-list>
</template>

<script>
import {
	orderBy,
} from 'lodash';
import AnonymizeNoteButton from './AnonymizeNoteButton.vue';

/**
 * A component that displays Notes (like UserNotes or OrderNotes) in a list.
 *
 * @typedef Note
 * @type {object}
 * @property {string} creatorName - By whom this note was created
 * @property {number} id - The id of the note in the database
 * @property {Date} date - When this note was created
 * @property {string} text - The text of the note
 */
export default {
	name: 'NoteList',
	components: {
		AnonymizeNoteButton
	},

	props: {
		notes: {
			type: Array,
			required: true,
		},
		anonymized: {
			type: Boolean,
			required: true
		},
		modelName: {
			type: String,
			required: true,
		},
	},

	updated () {
		// Scroll to bottom
		this.$el.scrollTop = this.$el.scrollHeight;
	},

	methods: {
		/**
		 * Covert notes array prop to timeline array
		 *
		 * @returns {Array}
		 */
		constructTimeline () {
			let datedNotes = [];

			this.notes.forEach((note) => {
				datedNotes.push(this.addTimeStrings(note));
			});
			datedNotes = orderBy(datedNotes, ['dateObject', ]);

			const noteTimeline = [[], ];
			let noteDay = 0;

			for (let i = 0; i < datedNotes.length; i++) {
				if (i !== 0 && datedNotes[i].date !== datedNotes[i - 1].date) {
					noteTimeline.push([]);
					noteDay = noteDay + 1;
				}

				noteTimeline[noteDay].push(datedNotes[i]);
			}

			return noteTimeline;
		},

		/**
		 * Add separate date object, day string and time string properties for note
		 *
		 * @param {object} note
		 * @returns {object}
		 */
		addTimeStrings (note) {
			const date = new Date(note.createdAt);

			return {
				...note,
				dateObject: date,
				time: date.toLocaleTimeString('en-NL', {
					hour12: false, hour: '2-digit', minute: '2-digit'
				}),
				date: date.toLocaleDateString('nl-NL')
			};
		},
	}
};
</script>

<style scoped>
	.v-list-item__content {
		overflow: visible;
	}

	.date-span {
		position: sticky;
		top: 0;
		z-index: 1;
	}
</style>

